import { Link } from 'react-router-dom';

export default function Products() {
  const products = [
    {
      title: 'Standard Stretch Tents',
      image: '/assets/img/2774bcfc1052.webp',
      description: 'Our high-performance stretch tents offer unmatched versatility and style. Perfect for weddings, corporate events, and festivals. Available in multiple sizes with customizable configurations.',
      features: ['Waterproof fabric', 'UV resistant', 'Fire rated', 'Easy setup'],
      link: '/products/standard-stretch-tents',
    },
    {
      title: 'Custom Stretch Tents',
      image: '/assets/img/bb8781b5799f.webp',
      description: 'Built to your exact specifications, our custom stretch tents are tailored in size, shape, and colour to match your vision. Whether you need an unconventional footprint or a unique configuration, we engineer it from scratch.',
      features: ['Made to measure', 'Custom colours', 'Unique shapes', 'Bespoke configurations'],
      link: '/products/custom-stretch-tents',
    },
    {
      title: 'Custom Printed Skins',
      image: '/assets/img/0f5fb24fd382.webp',
      description: 'Transform your brand into a statement with a fully custom-printed skin for your stretch tent. High-resolution, full-colour printing directly onto the skin delivers maximum visual impact, perfect for brand activations, product launches, and sponsored events.',
      features: ['Full-colour print', 'Brand customisation', 'High-res graphics', 'Dye-sublimation'],
      link: '/products/custom-printed-skins',
    },
    {
      title: 'Bespoke Decor',
      image: '/assets/img/decor-15.webp',
      description: 'Elevate your event beyond the structure itself with our bespoke decor services. From luxurious fabric draping and ambient lighting to floral installations and custom styling, we craft immersive environments tailored to your theme, turning any stretch tent into a stunning, fully dressed venue.',
      features: ['Fabric draping', 'Ambient lighting', 'Floral styling', 'Themed installations'],
      link: '/products/bespoke-decor',
    },
  ];

  return (
    <section id="products" className="py-20 bg-gradient-to-br from-teal-500 to-teal-600">
      <div className="w-full px-6 sm:px-10 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Explore Our Products
          </h2>
          <p className="text-lg text-white/80 mx-auto">
            Discover our range of innovative stretch tent solutions designed for every occasion
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((product, index) => (
            <div
              key={index}
              className="group bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden hover:bg-white/20 transition-all duration-300"
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-6 left-6">
                  <h3 className="text-2xl font-bold text-white mb-2">
                    {product.title}
                  </h3>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <p className="text-sm text-white/85 mb-4 leading-relaxed">
                  {product.description}
                </p>

                {/* Features */}
                <div className="flex flex-wrap gap-2 mb-6">
                  {product.features.map((feature, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-1 bg-white/20 text-white text-xs font-medium rounded-full"
                    >
                      {feature}
                    </span>
                  ))}
                </div>

                {/* CTA Button */}
                <Link
                  to={product.link}
                  className="inline-flex items-center gap-2 text-white hover:text-white/80 font-semibold text-sm group/btn whitespace-nowrap"
                >
                  <span>View Details</span>
                  <i className="ri-arrow-right-line text-lg group-hover/btn:translate-x-1 transition-transform"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}